export function camelize(str: string) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase()
  }).replace(/\s+/g, '')
}

export function isPromise(promiseOrAny: any | Promise<any>): promiseOrAny is Promise<any> {
  return promiseOrAny && promiseOrAny.then && typeof promiseOrAny.then === 'function'
}
